<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  close="true"
  (focusHeader)="shownContent()"
  [title]="titlePage"
>
</app-ion-common-header>

<div
  class="content-custom"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div class="content-scroll-custom">
    <div class="img-label-content">
      <img
        class="img-button approved-icon"
        [src]="icon"
        alt="icon"
        aria-hidden="true"
      />
    </div>

    <div class="conent-center conent-center--ph-0 center-info">
      <h1 class="title-size">{{ titleContent }}</h1>
      <div class="text-rg" [innerHTML]="description"></div>
    </div>
    <div class="likert" *ngIf="likert">
      <form [formGroup]="form" autocomplete="off" (submit)="submitForm()">
        <ids-likert formControlName="likertOptions" (change)="responseChangeLabel($event)" gender="female">
          <h2 class="ids-body-textids-body-text -bold space-h">
            O que achou dessa experiência?
          </h2>
          <p class="ids-body-text -small space-h">
            Sua avaliação é muito importante para evolução do íon, deixe sua
            opinião e/ou sugestões.
          </p>
        </ids-likert>
        <div *ngIf="form.controls.likertOptions.value" class="space-h">
          <ids-form-field
            *ngIf="isNegativeAnswer() || isPositiveAnswer()"
            label="{{
              isPositiveAnswer()
                ? 'O que mais você gostou? (opcional)'
                : 'O que mais poderia melhorar? (opcional)'
            }}"
            description="{{ characters }} caracteres restantes"
            thresholdAnnounce="20"
          >
            <textarea
              idsInput
              id="additional-text"
              maxlength="280"
              rows="3"
              cols="30"
              (ngModelChange)="countCharacter($event)"
              formControlName="comment"
            ></textarea>
          </ids-form-field>

          <div aria-hidden="true" id="text-counter" class="ids-label -small text-counter">
            {{ maxLength - form.controls.comment.value.length}} caracteres restantes
          </div>
          <button idsMainButton type="submit"  #buttonRef="idsOverlayOrigin" aria-label="enviar resposta" idsOverlayOrigin (click)="sendResponse($event)">
            enviar resposta
          </button>
        </div>
      </form>
    </div> 
    <div class="feedback-likert feedback-likert--success" *ngIf="likertSuccess">
      <h2 id="feedback-likert-title" class="ids-body-textids-body-text -bold">Agradecemos sua resposta!</h2>
    </div>
    <div class="feedback-likert feedback-likert--error" *ngIf="likertError">
      <h2 id="feedback-likert-title" class="ids-body-textids-body-text -bold">Desculpe, estamos passando por instabilidade.</h2>
      <p><span>Por favor, tente novamente mais tarde.</span></p>
    </div>
  </div>
</div>


<app-ion-common-button 
  class="borderTop" 
  label="Ir para página inicial"  
  [typeButton]="verifyIfTestAbActive() ? 'light' : 'dark'" 
  positionButton="block"
  [attr.aria-hidden]="ariaHidden" 
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
  (clickButton)="endJourneyNative()"
></app-ion-common-button>

<app-ion-common-button 
  *ngIf="verifyIfTestAbActive()" 
  label="Conhecer produtos" 
  typeButton="dark" 
  positionButton="block"
  [attr.aria-hidden]="ariaHidden" 
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
  (clickButton)="handleClickTestAb()"
></app-ion-common-button>

<div class="sr-only" aria-live="assertive">{{ voicePageLabel }}</div>
